<template>
  <div id="app" :class="classBreakpoints">
    <router-view v-if="$auth.ready()"/>
    <loader v-if="loading" transparent></loader>
  </div>
</template>

<script>
  import Loader from './components/Loader';
  import { mapState } from 'vuex';

  export default {
    name      : 'app',
    components: { Loader },
    computed  : {
      ...mapState({
        loading: state => state.loading,
      }),
      classBreakpoints() {
        return {
          'viewport-xs': this.$vuetify.breakpoint.xsOnly,
          'viewport-sm': this.$vuetify.breakpoint.smOnly,
          'viewport-md': this.$vuetify.breakpoint.mdOnly,
          'viewport-lg': this.$vuetify.breakpoint.lgOnly,
          'viewport-xl': this.$vuetify.breakpoint.xlOnly,
        };
      }
    }
  };
</script>

<style lang="scss">
  #app {
    *,
    *:before,
    *:after {
      word-break: normal;
      outline: none !important;
    }
  }
</style>
